<template>
    <div>
        <!-- Label -->
        <label :for="field.id" class="block text-sm font-medium text-gray-700 mb-2">
            {{ field.label }}
            <span v-if="field.required" class="text-red-500">*</span>
        </label>

        <!-- Select Dropdown -->
        <select :id="field.id"
            class="block w-full px-3 py-2 border border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
            <option v-for="option in field.options" :key="option" :value="option">
                {{ option }}
            </option>
        </select>

        <!-- Field Description -->
        <p v-if="field.description" class="text-xs text-gray-500 mt-2">
            {{ field.description }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: String, // Ensure it's a String
            default: ''
        }
    }
};
</script>
